import React from 'react';
import { useStyletron } from 'baseui';
// import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { EMPTY_OBJECT, FormBuilder } from 'commons-ui';
import { ContentPropsT } from '../../constants';
import useFilter from '../../utils/useFilter';
import { FORM_FIELD_CONFIG, FORM_LAYOUT_CONFIG, validateionSchema } from '../../utils/formConfig';

const Content = (props: ContentPropsT) => {
	const { handleFilterSubmit, onClose } = props;
	const [css] = useStyletron();

	const { showLoader, setShowLoader, handleFormCancel, handleFormSubmit } = useFilter({ handleFilterSubmit, onClose });
	return (
		<div className={css({ width: '50vw' })}>
			<FormBuilder
				data={EMPTY_OBJECT}
				mode='create'
				showLoader={showLoader}
				handleFormSubmit={handleFormSubmit}
				handleFormCancel={handleFormCancel}
				setShowLoader={setShowLoader}
				fieldConfig={FORM_FIELD_CONFIG}
				layoutConfig={FORM_LAYOUT_CONFIG}
				buttonLabels={{
					submitLabel: 'Submit',
					discardLabel: 'Cancel'
				}}
				hidePopUp
				validationSchema={validateionSchema}
			/>
		</div>
	);
};

export default Content;
